// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__btPr3","content":"style_content__LLba1","button":"style_button__G0L0J","title":"style_title__h559N","info":"style_info__J5JpN"};